import { DoubleChanceEnum } from "../../Enums/ValueEnums";

export default class ValueDoubleChance {
    public value: DoubleChanceEnum = null;
}